import $ from 'jquery';

import '@accessible360/accessible-slick';

// Foundation
import foundation from './modules/foundation'; /* eslint-disable-line */


// jquery match height NMP
import jqueryMatchHeight from 'jquery-match-height';

import fancyBox from './modules/fancybox';

import general from './modules/general';
import frontpage from './modules/frontpage';

import course from './modules/course';

import accordion from './modules/accordion';

import popularTab from './modules/popularTab';


document.addEventListener('DOMContentLoaded', function () {

	$( document ).foundation();

	general.init();
	frontpage.init();
	fancyBox.init();
	course.init();
	accordion.init();
	popularTab.init();

	$('.slick').slick();
	$('.slick-cloned').find('a').removeAttr('data-fancybox'); // remove duplicate fancbox

}, false);